const buttonFormMaintenance = {
  cancel: 'CANCEL MAINTENANCE',
  send_to_maintenance: 'SEND TO MAINTENANCE',
  done: 'COMPLETE MAINTENANCE',
  send_back_to_maintenance: 'RETURN TO MAINTENANCE'
};

export default buttonFormMaintenance;